import api from '../lib/api';

export interface Agent {
  id: string;
  employeeId: string;
  userId?: string | null;
  organizationId?: string;
  firstName: string;
  lastName: string;
  email: string;
  skills?: any[]; // Array of skill relations from Prisma
  status: 'ACTIVE' | 'INACTIVE' | 'ON_LEAVE' | 'TERMINATED';
  channel?: string;
  timezone?: string;
  targetUtilization?: number;
  createdAt?: string;
  updatedAt?: string;
  // Legacy fields for backward compatibility
  languages?: string[];
  currentState?: {
    state: 'AVAILABLE' | 'ON_CALL' | 'ON_BREAK' | 'LOGGED_OUT' | 'MEETING' | 'LUNCH' | 'OFFLINE' | 'CALLOUT' | 'NOT_CLOCKED_IN';
    startTime: string;
    duration: number;
    source: 'MANUAL' | 'ZENDESK_WEBHOOK' | 'KUSTOMER_WEBHOOK' | 'DECAGON_WEBHOOK' | 'SYSTEM';
  } | null;
}

export interface CreateAgentDto {
  employeeId: string;
  firstName: string;
  lastName: string;
  email: string;
  skills?: string[];
  languages?: string[];
  timezone: string;
  targetUtilization?: number;
  status?: 'ACTIVE' | 'INACTIVE' | 'ON_LEAVE' | 'TERMINATED';
}

export interface UpdateAgentDto {
  firstName?: string;
  lastName?: string;
  skills?: string[];
  languages?: string[];
  status?: 'ACTIVE' | 'INACTIVE' | 'ON_BREAK';
  timezone?: string;
  targetUtilization?: number;
}

export const agentsService = {
  getAll: async (): Promise<Agent[]> => {
    const { data } = await api.get('/agents');
    return data;
  },

  getAllWithCurrentState: async (): Promise<Agent[]> => {
    const { data } = await api.get('/agents/with-current-state');
    return data;
  },

  getById: async (id: string): Promise<Agent> => {
    const { data } = await api.get(`/agents/${id}`);
    return data;
  },

  create: async (agent: CreateAgentDto): Promise<Agent> => {
    const { data } = await api.post('/agents', agent);
    return data;
  },

  update: async (id: string, agent: UpdateAgentDto): Promise<Agent> => {
    const { data } = await api.patch(`/agents/${id}`, agent);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/agents/${id}`);
  },
};
